import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicContactsService {
  constructor(private publicHttp: PublicHttpClientService) {}
  public addContact({
    first_name,
    middle_name = null,
    first_last_name = null,
    second_last_name = null,
    phones = [],
    emails = [],
    dealership_id = null,
    source_channel = null,
  }): Observable<any> {
    const params = {
      first_name,
      middle_name,
      first_last_name,
      second_last_name,
      phones,
      emails,
      dealership_id,
      source_channel,
    };
    return this.publicHttp
      .post("/api/public/contact", params)
      .pipe(tap((_) => console.log("PublicContactsService.addContact: Ok.")));
  }

  public assignOnline(id: string | number, media_url: string = undefined): Observable<any> {
    const params = {
      id,
      media_url,
    };
    return this.publicHttp
      .post("/api/public/contact/assign_online", params)
      .pipe(tap((_) => console.log("PublicContactsService.assignOnline: Ok.")));
  }

  public toggleActive(id: string | number, reason?: string): Observable<any> {
    return this.toogleActive(id, reason);
  }

  public toogleActive(id: string | number, reason?: string): Observable<any> {
    const params = {
      id,
      reason,
    };
    return this.publicHttp
      .post(`/api/contact/${id}/toogle_active`, params)
      .pipe(tap((_) => console.log("PublicContactsService.toogleActive: Ok.")));
  }

  public getPersons(id: string): Observable<any> {
    return this.publicHttp
      .get(`/api/contact/${id}/persons`)
      .pipe(tap((_) => console.log("PublicContactsService.getPersons: Ok.")));
  }
}
